import React from 'react';

import { QRCodesImport } from './qrcodes/qrcodes';
import { ConditionsImport } from './conditions/conditions';
import { TransactionsImport } from './transactions/transactions';
import { PaidInstallationsImport } from './paid-installations/paid-installations';


export const tabs = [
  {
    id: 0,
    name: 'Импорт QR',
    component: QRCodesImport, 
  },
  {
    id: 1,
    name: 'Техническое состояние',
    component: ConditionsImport, 
  },
  {
    id: 2,
    name: 'Транзакции',
    component: TransactionsImport,
  },
  {
    id: 3,
    name: 'Платные установки',
    component: PaidInstallationsImport,
  }
];
